import React, { createContext, useContext } from 'react';
import { ComputeResourceDiscoveryApi } from '../../api';
import { CRDAWSConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';
import { useRefreshContext } from '../RefreshContext';

interface AWSContextProps {
  api: ComputeResourceDiscoveryApi;
  awsConfigs: CRDAWSConfig[];
  projectCode: string;
  refreshContext?: ReturnType<typeof useRefreshContext>;
}

const AwsContext = createContext<AWSContextProps | undefined>(undefined);

export const useAwsContext = () => {
  const context = useContext(AwsContext);
  if (!context) {
    throw new Error('AWSContext must be used within a AWSProvider');
  }
  return context;
};

export const AwsContextProvider: React.FC<
  Omit<AWSContextProps, 'refreshContext'> & { children: React.ReactNode }
> = ({ api, awsConfigs, projectCode, children }) => {
  const refreshContext = useRefreshContext();

  return (
    <AwsContext.Provider
      value={{
        api,
        awsConfigs,
        projectCode,
        refreshContext,
      }}
    >
      {children}
    </AwsContext.Provider>
  );
};
